import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "login-wrapper" };
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = { class: "form-header dark clearfix" };
const _hoisted_5 = { class: "float-start" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa-stack fa-lg fa-2x white-text" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-circle fa-stack-2x" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text" })
], -1 /* HOISTED */);
const _hoisted_7 = { class: "content-title" };
const _hoisted_8 = { class: "form-body clearfix bg-white text-center" };
const _hoisted_9 = {
    key: 0,
    class: "p-4"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-3x mb-3" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", null, "Completing SSO authentication...", -1 /* HOISTED */);
const _hoisted_12 = {
    key: 1,
    class: "p-4"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-danger mb-3" }, null, -1 /* HOISTED */);
const _hoisted_14 = { class: "text-danger" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("h1", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.statusMessage), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                    (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _hoisted_11
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (_ctx.hasError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */),
                            _createTextVNode(),
                            _createVNode(_component_router_link, {
                                to: { name: 'login' },
                                class: "btn btn-primary mt-3"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tBack to Login\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ])
    ]));
}
